import '../../scss/ExamDetail.scss'
import { IoMdMenu, IoIosInformationCircleOutline, IoMdExit } from "react-icons/io";
import { MdSettingsAccessibility } from "react-icons/md";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import Navmenudetail from './Navmenudetail';
import React, { useState, useRef, useEffect } from "react";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import TypeTracNghiem from './typequestion/TypeTracNghiem';
import TypeTracNghiemMulti from './typequestion/TypeTracNghiemMulti';
import TypeSelect from './typequestion/TypeSelect';
import { ThiTrucTuyenService } from 'services/ThiTrucTuyenService';
import { dangbaiService } from 'services/dangbaiService';
import { FaBookmark } from "react-icons/fa";
import { Clock } from '../countdown';
import { CountdownV2 } from '../CountdownV2';
import TypeSapXep from './typequestion/TypeSapXep';
import TypeSapXepV2 from './typequestion/TypeSapXepV2';
import TypeTuLuan from './typequestion/TypeTuLuan';
import { ProgressSpinner } from 'primereact/progressspinner';
import NavInfo from './NavInfo';
import ReviewQuestion from './ReviewQuestion';
import { useLocation, useNavigate } from 'react-router-dom';
import { dethitructuyenService } from 'services/dethitructuyenService';
import {
    initExamProgress,
    getExamProgress,
    markExamTypeCompleted,
    getNextExamType,
    isAllExamTypesCompleted,
    getExamTypeRoute
} from 'utils/examProgress';

export default function StartExamViet() {
    var thitructuyen = localStorage.getItem('thitructuyen');
    var timer = localStorage.getItem('countDown');
    var userId = localStorage.getItem('User_Id');
    var IdDeThi = localStorage.getItem('IdDeThi');
    const username = localStorage.getItem('fullname');

    if (IdDeThi == null || IdDeThi == "" || userId == null || username == "" || username == null) {
        window.location.href = '/'
    }
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [visibleInFo, setVisibleInFo] = useState(false);
    const [visiblereview, setvisiblereview] = useState(false);
    const [arrIdQuestion, setarrIdQuestion] = useState([]);
    const [arrcautraloi, setarrcautraloi] = useState([]);
    const [indexDF, setIndexDF] = useState(0);
    const [dataQuestion, setdataQuestion] = useState([]);
    const [loading, setLoading] = useState(false);
    const [socauhoi, setSoCauHoi] = useState(0);
    const [thoigian, setThoiGian] = useState(0);
    const [IdThongTinUser, setIdThongTinUser] = useState(0);
    const [count, setcount] = useState(timer);
    const [motadau, setmotadau] = useState('');
    const [motacuoi, setmotacuoi] = useState('');
    const [fileDinhKem, setFileDinhKem] = useState('');
    const countRef = useRef();
    const [type, setType] = useState("");
    const [idQuestion, setIdQuestion] = useState(0);
    const [idNhom, setIdNhom] = useState(0);
    const [valueSelected, setvalueSelected] = useState(0);
    const [arrBook, setarrBook] = useState(JSON.parse(localStorage.getItem('arrBookMark')) || []);

    const [showForceFullscreen, setShowForceFullscreen] = useState(false);
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const openDetailMenu = () => {
        setVisible(true);
    }

    const onCloseDetailMenu = () => {
        setVisible(false);
    }

    const toast = useRef(null);

    const accept = () => {
        toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    }

    const reject = () => {
        // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }

    const toggleAudio = async () => {
        try {
            const el = audioRef.current;
            if (!el) return;

            const playCountKey = `playCount_${userId}_viet_group_${idNhom}_${IdDeThi}_${indexDF}`;
            const currentCount = parseInt(localStorage.getItem(playCountKey) || '0');

            if (isPlaying) {
                el.pause();
                setIsPlaying(false);
            } else {
                if (currentCount >= 2) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Thông báo',
                        detail: 'Bạn đã hết lượt nghe cho phần này (tối đa 2 lần).',
                        life: 3000
                    });
                    return;
                }

                // Nếu bắt đầu nghe (lượt 1 hoặc 2), thì nghe lại từ đầu
                el.currentTime = 0;
                await el.play();
                setIsPlaying(true);

                const newCount = currentCount + 1;
                localStorage.setItem(playCountKey, newCount);
            }
        } catch (e) {
            // ignore play error
        }
    };

    // Helper function: Tìm câu hỏi đầu tiên chưa có đáp án
    const findFirstUnansweredQuestion = async (questionIdList, userId) => {
        if (!questionIdList || questionIdList.length === 0) {
            return -1;
        }

        // Kiểm tra từng câu hỏi để tìm câu đầu tiên chưa có đáp án
        for (let i = 0; i < questionIdList.length; i++) {
            const questionId = questionIdList[i];

            // Bỏ qua nếu là nhóm câu hỏi (object có idnhom)
            if (typeof questionId === 'object' && questionId.idnhom) {
                continue;
            }

            try {
                // Gọi API để kiểm tra xem câu hỏi này đã có đáp án chưa
                // Chỉ gửi attempt_code nếu có (để backend check Redis)
                const attemptCode = localStorage.getItem('exam_attempt_code');
                const result = await ThiTrucTuyenService.getdetailquestion(questionId, userId, attemptCode);

                // Nếu không có selected hoặc selected rỗng/null, đây là câu hỏi đầu tiên chưa làm
                const selected = result?.data?.data?.selected;
                if (!selected ||
                    (selected.id_cautraloi === null && !selected.vanbantraloi) ||
                    (Array.isArray(selected.id_cautraloi) && selected.id_cautraloi.length === 0)) {
                    return i;
                }
            } catch (error) {
                console.error(`Error checking question ${questionId}:`, error);
                // Nếu có lỗi, tiếp tục kiểm tra câu tiếp theo
                continue;
            }
        }

        // Nếu tất cả câu hỏi đều có đáp án, trả về -1 (sẽ bắt đầu từ câu đầu tiên)
        return -1;
    };

    const confirmExit = () => {
        confirmDialog({
            message: 'Are you sure you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept,
            reject
        });
    };

    useEffect(() => {
        loadData();
    }, []);

    // Ngăn chặn công cụ tìm kiếm trình duyệt (Ctrl+F, Ctrl+F3) trong lúc thi
    useEffect(() => {
        const blockSearchShortcuts = (e) => {
            if (e.ctrlKey && (e.key === 'f' || e.key === 'F' || e.key === 'F3')) {
                e.preventDefault();
                e.stopPropagation();
            }
            if (e.key === 'F3') {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        document.addEventListener('keydown', blockSearchShortcuts, true);
        return () => {
            document.removeEventListener('keydown', blockSearchShortcuts, true);
        };
    }, []);

    // Best-effort: cố gắng giữ fullscreen trong màn StartExamViet
    useEffect(() => {
        // Đánh dấu đang trong màn thi để tự động bật lại fullscreen sau khi reload
        sessionStorage.setItem('exam_fullscreen_required', 'true');

        const requestFullScreen = async () => {
            try {
                const el = document.documentElement;
                if (document.fullscreenElement) {
                    setShowForceFullscreen(false);
                    return true;
                }
                if (el?.requestFullscreen) {
                    await el.requestFullscreen();
                    setShowForceFullscreen(false);
                    return true;
                }
            } catch (e) {
                console.error('requestFullscreen error', e);
            }
            return false;
        };

        // Kiểm tra và bật fullscreen (bao gồm cả sau khi reload)
        const checkAndRequestFullscreen = async () => {
            if (!document.fullscreenElement) {
                const success = await requestFullScreen();
                if (!success) {
                    // Nếu không bật được, hiển thị Dialog yêu cầu user click
                    setShowForceFullscreen(true);
                }
            }
        };

        // Gọi ngay khi mount (bao gồm cả sau khi reload)
        checkAndRequestFullscreen();

        const onFsChange = async () => {
            if (document.fullscreenElement) {
                setShowForceFullscreen(false);
            } else {
                // Tự động bật lại fullscreen ngay khi user cố tắt
                const success = await requestFullScreen();
                if (!success) {
                    // Nếu không được, hiển thị modal yêu cầu user click
                    setShowForceFullscreen(true);
                }
            }
        };
        document.addEventListener('fullscreenchange', onFsChange);
        return () => {
            document.removeEventListener('fullscreenchange', onFsChange);
        };
    }, []);


    useEffect(() => {
        getDetailEx();
    }, []);

    const getDetailEx = async () => {
        var typeExam = localStorage.getItem('typeExam');

        var body = {
            code: typeExam
        }
        let result = await dangbaiService.getdetail(body);
        if (result.data) {
            const apiTime = result.data.data.thoigian * 60;
            setThoiGian(apiTime);
            setType(result.data.data.ma);

            // Kiểm tra và reset thời gian nếu chuyển dạng bài
            const lastTimerType = localStorage.getItem('lastTimerType');
            if (lastTimerType !== typeExam) {
                setcount(apiTime);
                localStorage.setItem('countDown', apiTime);
                localStorage.setItem('lastTimerType', typeExam);
            }
        }
    }
    const addThongTinUser = async () => {
        var typeExam = localStorage.getItem('typeExam');
        let attemptCode = localStorage.getItem('exam_attempt_code');
        if (!attemptCode) {
            attemptCode = `ATT_${userId}_${IdDeThi}_${Date.now()}`;
            localStorage.setItem('exam_attempt_code', attemptCode);
        }
        const attemptOrderMap = {
            'NGUPHAP': 1,
            'NGHE': 2,
            'DOC': 3,
            'VIET': 4,
            'NOI': 5
        };
        const attemptOrder = attemptOrderMap[typeExam] || null;
        let body = {
            type_exam: typeExam,
            user_id: userId,
            dethitructuyen_id: IdDeThi,
            dethitructuyen_name: localStorage.getItem('TenDeThi') || null,
            attempt_code: attemptCode,
            attempt_order: attemptOrder
        }
        let result = await ThiTrucTuyenService.addthongtinuser(body);
        setIdThongTinUser(result?.data?.newId)
    }

    const loadData = async () => {
        var typeExam = localStorage.getItem('typeExam');

        // Khởi tạo progress nếu chưa có hoặc đề thi khác
        const progress = getExamProgress();
        const currentDethiId = String(IdDeThi || '');
        const progressDethiId = progress ? String(progress.dethiId || '') : '';

        // Kiểm tra xem đã có lượt thi với attempt_code + type_exam + dethitructuyen_id chưa
        let attemptCode = localStorage.getItem('exam_attempt_code');
        let isExistingAttempt = false;

        if (attemptCode) {
            try {
                const checkResult = await ThiTrucTuyenService.checkattempt({
                    user_id: userId,
                    dethitructuyen_id: IdDeThi,
                    type_exam: typeExam,
                    attempt_code: attemptCode
                });
                isExistingAttempt = checkResult?.data?.exists === true;
            } catch (e) {
                console.error('checkattempt error', e);
            }
        }

        // Nếu chưa có progress hoặc đề khác → khởi tạo progress mới
        if (!progress || progressDethiId !== currentDethiId || !progressDethiId) {
            // Nếu đã có lượt thi với attempt_code này thì clear đáp án cũ
            if (isExistingAttempt) {
                try {
                    await ThiTrucTuyenService.clearndata({ userId: userId, IdDeThi: IdDeThi });
                } catch (e) {
                    console.error('clearndata error', e);
                }
            }

            initExamProgress(IdDeThi);

            // Khôi phục completedTypes từ database:
            // - Resume session (có attempt_code chưa hoàn thành)
            // - Hoặc Phase 2 (full_exam): cần đánh dấu NOI đã xong từ Phase 1
            const needsRestore = (attemptCode && !isExistingAttempt) || localStorage.getItem('exam_mode') === 'full_exam';
            if (needsRestore) {
                try {
                    const resumeRes = await ThiTrucTuyenService.checkResumeAttempt({
                        user_id: userId,
                        dethitructuyen_id: IdDeThi
                    });
                    const dataResume = resumeRes?.data;
                    if (dataResume?.completed_types?.length > 0 && !dataResume?.is_fully_completed) {
                        const restoredProgress = getExamProgress();
                        if (restoredProgress) {
                            // Đánh dấu các dạng đã hoàn thành từ database (bao gồm NOI từ Phase 1)
                            dataResume.completed_types.forEach(type => {
                                markExamTypeCompleted(type);
                            });
                        }
                    }
                } catch (e) {
                    console.error('Restore progress from DB error', e);
                }
            }
        }

        let body = {
            typeExam: typeExam,
            isthitructuyen: 1, //1: thi truc tuyen
            userId: userId,
            IdDeThi: IdDeThi,
            kyThiId: localStorage.getItem('CaThiId') || localStorage.getItem('KyThiId') || null,
            attempt_code: attemptCode || null // Gửi attempt_code để backend load đáp án từ Redis
        }

        let result = await ThiTrucTuyenService.getdetailexam(body);
        const dataExam = result?.data || {};

        // Trường hợp không có câu hỏi → hiển thị thông báo và dừng lại, tránh lỗi null.length
        if (!Array.isArray(dataExam.dataId) || dataExam.dataId.length === 0) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Thông báo',
                detail: 'Đề thi hiện không có câu hỏi Writing nào. Vui lòng liên hệ quản trị viên.',
                life: 5000
            });
            setLoading(false);
            return;
        }

        setarrIdQuestion(dataExam.dataId);
        setarrcautraloi(dataExam.datacautraloi);
        setSoCauHoi(dataExam.dataId.length);
        localStorage.setItem('arrIdCauHoi', dataExam.dataId);
        localStorage.setItem('arrCodeCauHoi', dataExam.dataCode);

        // Tìm câu hỏi đầu tiên chưa có đáp án (để resume)
        // attemptCode đã được khai báo ở trên trong loadData()
        let startIndex = 0;

        if (attemptCode) {
            // Nếu có attempt_code, tìm câu hỏi đầu tiên chưa có đáp án
            const foundIndex = await findFirstUnansweredQuestion(result.data.dataId, userId);
            if (foundIndex !== -1) {
                startIndex = foundIndex;
            }
        }

        setIndexDF(startIndex);
        await getCurrentQuestion(result.data.dataId, startIndex, 'default');

        addThongTinUser();
    }
    const confirmSubmit = () => {
        confirmDialog({
            message: (
                <p style={{ padding: '0 10px', margin: 0, fontSize: 14.5, lineHeight: 1.7, color: '#374151' }}>
                    Once you submit your test you will no longer have access to the questions.
                </p>
            ),
            header: 'Submit Test?',
            closable: false,
            defaultFocus: 'reject',
            acceptLabel: 'Submit test',
            rejectLabel: 'Cancel',
            accept: onsubmitexam,
        });
    };
    const onsubmitexam = async () => {
        const typeExam = localStorage.getItem('typeExam');
        const attemptCode = localStorage.getItem('exam_attempt_code');

        // Đồng bộ dữ liệu về DB ngay khi kết thúc 1 dạng bài
        try {
            if (IdThongTinUser) {
                await ThiTrucTuyenService.updatethongtinuser({
                    id: IdThongTinUser,
                    time_con_lai: count,
                    attempt_code: attemptCode || null,
                    type_exam: typeExam
                });
            }
        } catch (e) {
            console.error('updatethongtinuser (sync per skill) error', e);
        }

        // ========== TRIGGER AI CHẤM ĐIỂM WRITING ==========
        // PHẢI await trước khi navigate — nếu fire & forget, browser sẽ cancel
        // request khi chuyển trang, dẫn đến dữ liệu không được đẩy vào Redis Queue.
        if (typeExam === 'VIET' && userId && attemptCode) {
            try {
                const aiRes = await ThiTrucTuyenService.submitWritingAI(userId, attemptCode, typeExam);
                const requestId = aiRes?.data?.request_id || aiRes?.data?.job_id;
                if (requestId) {
                    localStorage.setItem('ai_writing_request_id', requestId);
                    console.info('[AI Writing] Submitted OK, requestId:', requestId);
                }
            } catch (err) {
                // Không alert user — chỉ log để admin theo dõi
                console.warn('[AI Writing] Submit failed (non-blocking):', err?.message);
            }
        }
        // =====================================================================

        // Đánh dấu dạng thi hiện tại đã hoàn thành
        markExamTypeCompleted(typeExam);

        // Kiểm tra xem còn dạng thi nào chưa thi không
        if (isAllExamTypesCompleted()) {
            // Đã thi hết tất cả, chuyển đến màn tổng hợp điểm
            navigate('/resultexam', { state: { IdThongTinUser: IdThongTinUser, time: count, isFinalResult: true } });
        } else {
            // Còn dạng khác, chuyển sang dạng tiếp theo
            const nextExamType = getNextExamType();
            if (nextExamType) {
                localStorage.setItem('typeExam', nextExamType);
                const nextRoute = getExamTypeRoute(nextExamType);
                navigate(nextRoute);
            } else {
                // Fallback: nếu không tìm được dạng tiếp theo, chuyển đến màn tổng hợp
                navigate('/resultexam', { state: { IdThongTinUser: IdThongTinUser, time: count, isFinalResult: true } });
            }
        }
    }

    const getCurrentQuestion = async (questionIdList, index, typeBtn = '') => {
        if (typeBtn == 'next') {
            // Submit đáp án của câu hiện tại trước khi chuyển
            await onSubmitQuestion(questionIdList[index]);

            index++;
            if (index <= socauhoi - 1) {
                setLoading(true);
                setIndexDF(index);
                if (typeof questionIdList[index] === 'string' || typeof questionIdList[index] === 'number') {
                    await loadDataQuestion(questionIdList[index]);
                }
                else {
                    await loadDataQuestionByIdNhom(questionIdList[index].idnhom)
                }
            } else {
                // Đã đến câu cuối cùng, hiện popup submit (không setLoading để giữ đáp án đã chọn)
                confirmSubmit();
                return;
            }
        }
        if (typeBtn == 'prev') {
            setLoading(true);
            index--;
            onSubmitQuestion(questionIdList[index + 1]);
            setIndexDF(index);
            if (typeof questionIdList[index] === 'string' || typeof questionIdList[index] === 'number') {
                await loadDataQuestion(questionIdList[index]);
            }
            else {
                await loadDataQuestionByIdNhom(questionIdList[index].idnhom)
            }
        }
        if (typeBtn == 'submit') {

        }
        if (typeBtn == 'default') {
            setLoading(true);
            if (typeof questionIdList[index] === 'string' || typeof questionIdList[index] === 'number') {
                await loadDataQuestion(questionIdList[index]);
            }
            else {
                await loadDataQuestionByIdNhom(questionIdList[index].idnhom)
            }
        }
    }


    const onChangeValue = (val) => {
        setvalueSelected(val);
    }
    const onSubmitQuestion = async (idquestion) => {
        if (valueSelected != 0 && (typeof idquestion === 'string' || typeof idquestion === 'number')) {
            // [Optimize] Không gọi API ở đây vì component con (TypeTracNghiem, TypeSelect, etc.)
            // đã tự gửi API khi user chọn đáp án. Chỉ reset state.
            if (Array.isArray(valueSelected)) {
                setvalueSelected([]);
            } else {
                setvalueSelected(0);
            }
        }
    }

    const renderQuestion = (dataQuestion) => {
        return (
            <>
                {
                    dataQuestion.length > 0 ?
                        dataQuestion.map((item, index) => {
                            return (
                                <div key={index}>
                                    {item.code == "TN" && <TypeTracNghiem thitructuyen={thitructuyen} onChangeValue={(val) => onChangeValue(val)} isNhom={true} data={item} userId={userId} time={count} overview={false}></TypeTracNghiem>}
                                    {item.code == "TN_MULTI" && <TypeTracNghiemMulti thitructuyen={thitructuyen} onChangeValue={(val) => onChangeValue(val)} isNhom={true} data={item} userId={userId} time={count} overview={false}></TypeTracNghiemMulti>}
                                    {item.code == "SEL" && <TypeSelect thitructuyen={thitructuyen} onChangeValue={(val) => onChangeValue(val)} isNhom={true} data={item} userId={userId} time={count} overview={false}></TypeSelect>}
                                    {item.code == "SX" && <TypeSapXepV2 isNhom={true} data={item} userId={userId} time={count} overview={false}></TypeSapXepV2>}
                                    {item.code == "VIET" && <TypeTuLuan key={item.id} isNhom={true} data={item} userId={userId} time={count} overview={false} indexDF={indexDF} index={index}></TypeTuLuan>}
                                </div>
                            )
                        })
                        :
                        <div key={dataQuestion.id}>
                            {dataQuestion.code == "TN" && <TypeTracNghiem thitructuyen={thitructuyen} isNhom={false} onChangeValue={(val) => onChangeValue(val)} data={dataQuestion} userId={userId} time={count} overview={false}></TypeTracNghiem>}
                            {dataQuestion.code == "TN_MULTI" && <TypeTracNghiemMulti thitructuyen={thitructuyen} isNhom={false} onChangeValue={(val) => onChangeValue(val)} data={dataQuestion} userId={userId} time={count} overview={false}></TypeTracNghiemMulti>}
                            {dataQuestion.code == "SEL" && <TypeSelect thitructuyen={thitructuyen} isNhom={false} onChangeValue={(val) => onChangeValue(val)} data={dataQuestion} userId={userId} time={count} overview={false}></TypeSelect>}
                            {dataQuestion.code == "SX" && <TypeSapXepV2 isNhom={false} data={dataQuestion} userId={userId} time={count} overview={false}></TypeSapXepV2>}
                            {dataQuestion.code == "VIET" && <TypeTuLuan key={dataQuestion.id} isNhom={false} data={dataQuestion} userId={userId} time={count} overview={false} indexDF={indexDF} index={0}></TypeTuLuan>}
                        </div>
                }

            </>
        )
    }

    const loadDataQuestion = async (IdCauHoi) => {
        setIdNhom(0);
        localStorage.setItem('IdQuestion', IdCauHoi);
        setIdQuestion(IdCauHoi);
        setLoading(true);
        const attemptCode = localStorage.getItem('exam_attempt_code');
        let result = await ThiTrucTuyenService.getdetailquestion(IdCauHoi, userId, attemptCode);
        const questionData = result.data.data;
        setdataQuestion(questionData);
        setFileDinhKem("");

        setLoading(false);
    }
    const loadDataQuestionByIdNhom = async (IdNhom) => {
        let a = { idnhom: IdNhom }
        localStorage.setItem('IdQuestion', JSON.stringify(a));
        setIdQuestion(a);
        setIdNhom(IdNhom);
        setLoading(true);
        const attemptCode = localStorage.getItem('exam_attempt_code');
        let result = await ThiTrucTuyenService.getquestionbyidnhom(IdNhom, userId, thitructuyen, attemptCode);
        const questionData = result.data.data.LstCauHoi;
        setdataQuestion(questionData);
        setmotadau(result.data.data.des);
        setmotacuoi(result.data.data.des_cuoi);
        setFileDinhKem(result.data.data.file);

        setLoading(false);
    }
    const openMenuLeft = async (val, idx) => {
        setLoading(true);

        if (typeof val == 'string' || typeof val == 'number') {
            await loadDataQuestion(val);
            setIndexDF(idx);
        }
        else {
            await loadDataQuestionByIdNhom(val.idnhom);
            setIndexDF(idx);
        }
    }
    const onUpdateBookMark = () => {
        var IdQuestion;
        if (idNhom == 0) {
            IdQuestion = localStorage.getItem('IdQuestion');

        }
        else {

            IdQuestion = JSON.parse(localStorage.getItem('IdQuestion'));
        }
        setIdQuestion(IdQuestion);
        let index = 0;
        var arrBookMark = JSON.parse(localStorage.getItem('arrBookMark')) || [];

        if (typeof IdQuestion === 'string' || typeof IdQuestion === 'number') {
            index = arrBookMark.indexOf(IdQuestion);
        }
        else {
            index = arrBookMark.findIndex(item => item.idnhom == IdQuestion.idnhom);
        }

        if (index !== -1) {
            // Nếu phần tử có trong mảng, xóa nó đi
            arrBookMark.splice(index, 1);
        } else {
            // Nếu phần tử không có trong mảng, thêm nó vào
            arrBookMark.push(IdQuestion);
        }
        localStorage.setItem('arrBookMark', JSON.stringify(arrBookMark));
        setarrBook(arrBookMark);
    }

    const renderTitle = () => {
        if (type == "NGUPHAP") {
            return "Grammar and Vocabulary";
        }
        else if (type == "NGHE") {
            return "Listening";
        }
        else if (type == "DOC") {
            return "Reading";
        }
        else if (type == "VIET") {
            return "Writing";
        }
        else {
            return "Speaking";
        }
    }


    return (
        <>
            <Dialog
                header="Yêu cầu chế độ toàn màn hình"
                visible={showForceFullscreen}
                closable={false}
                draggable={false}
                resizable={false}
                modal
                style={{ width: 'min(560px, 95vw)' }}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, paddingTop: 4 }}>
                        <Button
                            label="Bật lại toàn màn hình"
                            icon="pi pi-window-maximize"
                            className="p-button"
                            style={{
                                background: '#23085a',
                                borderColor: '#23085a',
                                boxShadow: '0 10px 18px rgba(35, 8, 90, 0.22)'
                            }}
                            onClick={async () => {
                                const requestFullScreen = async () => {
                                    try {
                                        const el = document.documentElement;
                                        if (document.fullscreenElement) return true;
                                        if (el?.requestFullscreen) {
                                            await el.requestFullscreen();
                                            return true;
                                        }
                                    } catch (e) {
                                        // Browser có thể chặn
                                    }
                                    return false;
                                };
                                const ok = await requestFullScreen();
                                setShowForceFullscreen(!ok);
                            }}
                        />
                    </div>
                }
            >
                <div style={{ display: 'flex', gap: 14, lineHeight: 1.5, padding: '6px 2px 2px 2px' }}>
                    <div
                        style={{
                            width: 44,
                            height: 44,
                            borderRadius: 12,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'rgba(35, 8, 90, 0.08)',
                            color: '#23085a',
                            flex: '0 0 auto'
                        }}
                    >
                        <i className="pi pi-window-maximize" style={{ fontSize: 18 }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginBottom: 6 }}>
                            Vui lòng bật chế độ toàn màn hình để tiếp tục
                        </div>
                        <div style={{ fontSize: 14, color: '#4b5563' }}>
                            Bạn đang thoát khỏi toàn màn hình. Bấm <b>Bật lại toàn màn hình</b> để quay lại và tiếp tục làm bài viết.
                        </div>
                        <div style={{ marginTop: 10, fontSize: 12, color: '#6b7280' }}>
                            Mẹo: Nếu trình duyệt chặn, hãy thử bấm lại nút một lần nữa.
                        </div>
                    </div>
                </div>
            </Dialog>
            <div style={{ height: '100vh' }}>
                <div className='col-12 d-flex justify-content-end div-header' >
                    <Clock
                        ref={countRef}
                        time={count}
                        timdeDF={thoigian}
                        onChange={data => setcount(data)}
                        onTimeout={onsubmitexam}
                    />

                </div>
                <div style={{ paddingTop: '80px' }}>

                    <div className="conatiner-div1">
                        <div>
                            <h2>{renderTitle()}</h2>
                        </div>
                        <div>
                            <div className="row" style={{ display: 'flex' }}>
                                <div className="col-8">
                                    <h2 className="title"> Question {indexDF + 1} of {socauhoi} </h2>
                                </div>
                            </div>

                            <div>

                                <div className="d-flex justify-content-end mb-4">
                                    <div style={{ backgroundColor: typeof idQuestion === 'string' || typeof idQuestion === 'number' ? (arrBook || []).includes(idQuestion) ? "#e7e6f1" : "white" : ((arrBook || []).filter(item => item.idnhom == idQuestion.idnhom).length > 0 ? "#e7e6f1" : "white") }} className="div2 cursor-pointer" onClick={() => onUpdateBookMark()}>
                                        <FaBookmark size={20} />
                                        <div>Bookmark</div>
                                    </div>
                                </div>

                            </div>



                        </div>

                    </div>
                    <div style={{ position: 'relative' }}>
                        {loading && (
                            <div style={{ position: 'absolute', inset: 0, zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <ProgressSpinner />
                            </div>
                        )}
                        <div className="conatiner-div1" >
                            <div>
                                <div >
                                    {dataQuestion.length > 0 &&
                                        <div style={{ fontWeight: '600' }} dangerouslySetInnerHTML={{ __html: motadau }}>
                                        </div>
                                    }
                                </div>


                            </div>

                            <div style={{ marginBottom: '30px' }}>
                                {renderQuestion(dataQuestion)}
                            </div>
                            <div style={{ marginBottom: dataQuestion.length > 0 ? '100px' : '50px' }}>
                                {dataQuestion.length > 0 &&
                                    <div style={{ fontWeight: '600' }} dangerouslySetInnerHTML={{ __html: motacuoi }}>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                </div>

                <div className='divfooter d-flex justify-content-between'>
                    <div className="menu-container align-items-center d-inline-flex">
                        <button className="btn1"
                            onClick={() => openDetailMenu()}
                        >
                            <span className="mat-button-wrapper">
                                <IoMdMenu size={24} />
                            </span>
                        </button>
                        <button className="btn1"
                            onClick={() => setVisibleInFo(true)}>
                            <span className="mat-button-wrapper">
                                <IoIosInformationCircleOutline size={24} />
                            </span>
                        </button>
                    </div>
                    <div className="nav-container ml-auto align-items-center d-inline-flex">
                        <button className="btn1" onClick={() => setvisiblereview(true)}>
                            <span className="mat-button-wrapper">
                                <IoMdExit size={24} />
                            </span>
                        </button>
                        <Button
                            disabled={indexDF == 0 || loading}
                            className="btn2 "
                            onClick={() => getCurrentQuestion(arrIdQuestion, indexDF, 'prev')}
                            style={{
                                width: "130px",
                                background: indexDF == 0 ? "#3333" : '#23085a',
                                color: indexDF == 0 ? "#23085a" : 'white',
                                borderColor: indexDF == 0 ? "#3333" : '#23085a'
                            }}
                            icon={loading ? 'pi pi-spinner pi-spin' : 'pi pi-arrow-left'}
                            label="Previous"
                        >
                        </Button>
                        <Button className="btn2 "
                            onClick={() => getCurrentQuestion(arrIdQuestion, indexDF, 'next')}
                            icon={loading ? 'pi pi-spinner pi-spin' : 'pi pi-arrow-right'}
                            label="Next"
                            disabled={loading}
                        >
                        </Button>
                    </div>
                </div>
            </div>

            <Navmenudetail
                arrcautraloi={arrcautraloi}
                visible={visible}
                onClose={onCloseDetailMenu}
                type={type}
                socauhoi={socauhoi}
                arrIdQuestion={arrIdQuestion}
                indexDF={indexDF}
                openMenuLeft={(val, idx) => openMenuLeft(val, idx)}
                arrBook={arrBook}
            >
            </Navmenudetail>

            <ReviewQuestion
                visible={visiblereview}
                onClose={() => setvisiblereview(false)}
                type={type}
                socauhoi={socauhoi}
                arrIdQuestion={arrIdQuestion}
                arrcautraloi={arrcautraloi}
                indexDF={indexDF}
                openMenuLeft={(val, idx) => openMenuLeft(val, idx)}
                onSubmit={confirmSubmit}
            >
            </ReviewQuestion>

            <NavInfo
                visible={visibleInFo}
                type={type}
                onClose={() => setVisibleInFo(false)}
            >

            </NavInfo>

            <ConfirmDialog
                closable={false}
                style={{
                    width: 'min(440px, 95vw)',
                    borderRadius: 16,
                    overflow: 'hidden',
                    boxShadow: '0 20px 60px rgba(35,8,90,0.18)',
                }}
                pt={{
                    header: {
                        style: {
                            padding: '24px 28px 8px',
                            fontSize: 18, fontWeight: 700,
                            color: '#1e1b4b',
                            borderBottom: 'none',
                            background: '#fff',
                        }
                    },
                    content: {
                        style: {
                            padding: '0 28px 20px',
                            background: '#fff',
                        }
                    },
                    footer: {
                        style: {
                            padding: '12px 28px 24px',
                            display: 'flex', justifyContent: 'flex-end',
                            gap: 12, background: '#fff',
                            borderTop: 'none',
                        }
                    },
                    rejectButton: {
                        style: {
                            border: '1.5px solid #d1d5db',
                            color: '#374151',
                            background: '#fff',
                            borderRadius: 8, fontWeight: 600,
                            padding: '10px 24px', minWidth: 110,
                        }
                    },
                    acceptButton: {
                        style: {
                            background: '#23085a',
                            border: '1.5px solid #23085a',
                            color: '#fff',
                            borderRadius: 8, fontWeight: 600,
                            padding: '10px 24px', minWidth: 110,
                        }
                    },
                    closeButton: {
                        style: { display: 'none' }
                    },
                    icon: { style: { display: 'none' } },
                }}
            />
            <Toast ref={toast} />
        </>
    )
}
